// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__TbxqJ","copy":"styles_copy__CQPY9","subcopy":"styles_subcopy__xb_If","heading":"styles_heading__tfnZb","steps":"styles_steps__qBlgv"};